<script setup>
defineEmits(["input"]);
defineProps({
  filter: {
    type: Object,
    required: true
  },
  readOnly: {
    type: Boolean,
    default: false
  }
});
</script>

<template>
    <label
        class="flex gap-2 text-sm items-center text-slate-900 hover:cursor-pointer"
    >
        <input
            type="radio"
            :checked="filter.checked"
            :value="filter.value"
            :disabled="readOnly"
            @input="$emit('input', filter.value)"
        />
        {{ filter.name }}
    </label>
</template>
